export const ROUTE_BASE_TOOL = '/tool'
export const ROUTE_BASE_TAG = '/tag'
export const ROUTE_BASE_SITE = '/site'
export const ROUTE_BASE_TOOLS_LANDING_PAGE = '/tools'
